export var PlaygroundActionType;
(function (PlaygroundActionType) {
    PlaygroundActionType["SET_INIT_PAYLOAD"] = "SET_INIT_PAYLOAD";
    PlaygroundActionType["SET_PAYLOAD"] = "SET_PAYLOAD";
    PlaygroundActionType["CLEAR_PAYLOAD"] = "CLEAR_PAYLOAD";
    PlaygroundActionType["CHANGE_MODE"] = "CHANGE_MODE";
    PlaygroundActionType["SET_CARD"] = "SET_CARD";
    PlaygroundActionType["SET_CARD_PAYLOAD"] = "SET_CARD_PAYLOAD";
    PlaygroundActionType["DELETE_CARD"] = "DELETE_CARD";
    PlaygroundActionType["REORDER_CARDS"] = "REORDER_CARDS";
    PlaygroundActionType["REORDER_CARDS_AND_POSTS_SETTINGS"] = "REORDER_CARDS_AND_POSTS_SETTINGS";
    PlaygroundActionType["SET_IS_CARD_DRAGGABLE"] = "SET_IS_CARD_DRAGGABLE";
    PlaygroundActionType["SET_POSTS_SETTINGS"] = "SET_POSTS_SETTINGS";
    PlaygroundActionType["CLEAR_ACTIONS"] = "CLEAR_ACTIONS";
    PlaygroundActionType["CREATE_NEW_LINKIE"] = "CREATE_NEW_LINKIE";
    PlaygroundActionType["GET_LINKIE_USERNAMES"] = "GET_LINKIE_USERNAMES";
})(PlaygroundActionType || (PlaygroundActionType = {}));
//# sourceMappingURL=playground-action.type.js.map